'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'refrigerator';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e026';
var svgPathData = ['M0 160l0 48 272 0 0-48-272 0zm320 0l0 48 64 0 0-48-64 0z', 'M88 0C39.4 0 0 39.4 0 88l0 72 272 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 64 0 0-72c0-48.6-39.4-88-88-88L88 0zM384 208l-64 0 0 120c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-272 0 0 240c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-240z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRefrigerator = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;